import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F19F6E",
      fillRule: "evenodd",
      d: "M20.753 19.206c.085.002.352-.047.486.03l.876.462v.902c.5.15 1.117.255 1.851.244a8.4 8.4 0 0 0 1.947-.25 4.5 4.5 0 0 1-.092-.624l.732-.735a3 3 0 0 1 .645-.028c.11.02.613.866.766.941-.002.12-.01.229-.192.415-.078.08-.298.26-.683.441.14.22.323.404.554.453.492.105 1.16-.46 1.16-.46s-.643 1.189-.918 1.248c-.275.06-1.04-.21-1.507-.634a1.1 1.1 0 0 1-.215-.286c-.543.131-1.226.198-2.197.203-.971.004-1.474-.157-2.04-.287a2.26 2.26 0 0 1-.715.857c-.658.471-1.209.262-1.4.242s-.703-1.327-.703-1.327.352.638 1.35.423c.276-.06.458-.24.576-.47-.44-.18-.722-.386-.876-.584-.268-.358-.178-.397-.178-.397.25-.141.655-.78.773-.779m.473 1.033q.009-.088.013-.174c-.106-.107-.246-.232-.325-.233-.055-.001-.125.039-.189.088.117.09.284.204.501.32m5.76-.35c-.078-.012-.163.046-.235.114.002.054-.008.258.116.266.103.006.338-.175.393-.21-.065-.067-.167-.154-.274-.17",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      d: "M24.03 21s-4.053-1.082-4.03-5.198V10h7.94l.06 5.77c.023 4.117-3.97 5.23-3.97 5.23"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M25.084 19.777c-.44-.151-.653-.518-1.085-.502-.394.014-.643.342-1.033.52a6 6 0 0 1-.543-.371 4.6 4.6 0 0 1-1.145-1.261q.087-.026.197-.047c.368-.07.752.404 1.183.484s.96-.484 1.329-.484c.359 0 .847.592 1.32.484s.658-.716 1.104-.694c.174.009.308.043.406.081a4.6 4.6 0 0 1-1.217 1.426q-.251.2-.516.364m2.073-2.633a1 1 0 0 0-.312-.081c-.482-.03-.675.604-1.253.604-.772 0-.968-.634-1.543-.634-.579 0-.772.634-1.35.634s-.92-.644-1.328-.639c-.147.002-.33.095-.505.212a4.8 4.8 0 0 1-.2-1.369c.227-.113.456-.204.61-.204.385 0 .965.618 1.35.618.387 0 .956-.618 1.352-.618.386 0 1.096.618 1.544.618.58 0 .849-.618 1.352-.618.146 0 .303.087.459.195a5 5 0 0 1-.176 1.282m.163-2.614c-.15-.07-.32-.121-.504-.121-.568 0-.947.484-1.447.463s-.827-.463-1.395-.463-.758.484-1.326.484-.758-.484-1.327-.484c-.28 0-.468.117-.655.236v-3.978h6.614z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M26.677 14.478c-.228.036-.426.155-.619.27-.225.135-.442.264-.689.253-.237-.012-.435-.132-.638-.256-.226-.137-.458-.278-.757-.278-.284 0-.474.14-.663.279-.19.14-.379.279-.663.279s-.474-.14-.663-.28c-.19-.139-.38-.278-.663-.278l-.08.004c.328-.285 1.232-.495 2.572-.437q.301.013.61.021c1.035.031 2.046.061 2.253.423",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M21.737 11.477c.005-.059.014-.1.014-.17.031-.014.18-.123.347-.14.069-.008.408.019.724.189.295.16.569.463.616.459.027-.002.65.082 1.227.094.489.01.947-.053.947-.053.033.009.43.054.6.331.142.234.065.703.055.73a4 4 0 0 1-.056.46 2.3 2.3 0 0 1-.125.416.4.4 0 0 0-.112.157c-.016.048.048.389.07.432.022.026-.109.027-.125-.026-.033-.035-.127-.374-.21-.38-.039-.03-.249-.046-.25.027 0 0-.005.132-.071.261-.064.124-.188.245-.222.249-.024-.027-.064-.062-.084-.092.02-.028.154-.208.12-.333-.035-.136-.24-.218-.26-.23-.026-.005-.309.08-.575.092-.398.017-.827-.033-.86-.013a.6.6 0 0 0-.22.232c-.063.119-.084.3-.086.33-.005.089-.14.105-.167-.065.012-.066.027-.1.027-.17-.013-.05-.045-.049-.083-.013 0 .04-.015.215-.075.301-.042.06-.13.044-.148.053-.003-.002.004-.164 0-.293a2 2 0 0 0-.028-.283c-.012-.022-.526-.207-.72-.602-.231-.471-.148-1.166-.158-1.191-.032-.046-.402-.006-.547-.079-.077-.038-.19-.19-.17-.3.016-.098.156-.156.21-.19.153-.093.372-.165.395-.19",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M16 0v16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M4.288 2.403 8 6.114 14.065.05A57 57 0 0 1 16 0v1.886L9.886 8 16 14.114V16h-1.886L8 9.886 1.886 16H.003v-.017q-.013-.923.027-1.898L6.114 8 2.467 4.353a9 9 0 0 1 1.821-1.95",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M14.555.031Q15.276.007 16 0L8.472 7.529l-.708-.708zM3.308 3.307l4.22 4.222-.706.707-4.157-4.157c.194-.26.408-.52.643-.772M.003 16v-.003L7.53 8.47l.707.708L1.414 16zm8.469-7.529.707-.707L16 14.586V16z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M10 .399V16H6V1.372q.168-.075.342-.143C7.272.875 8.544.6 10 .4",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M1.529 6H16v4H.442q.172-1.061.424-2.125S1.035 7.072 1.53 6",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M9.334.498V16H6.667V1.114C7.403.867 8.312.662 9.334.498",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M1.246 6.667H16v2.666H.558q.135-.728.308-1.458s.102-.487.38-1.208",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagFlk = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagFlk_default = SvgFlagFlk;

export { FlagFlk_default as default };
